import * as React from 'react';
import { Text, View } from 'react-native';

export default class AdMobInterstitial extends React.Component<object> {
  render() {
    return (
      <View>
        <Text>AdMobInterstitial component not supported on the web</Text>
      </View>
    );
  }
}
